module.exports = __webpack_public_path__ + "static/media/Homepage_Client_Logos.65cdd1f0.png";